module.exports = new __parcel__URL__("bug.ee818e22.svg").toString();